import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;
const LS_ADMIN_TOKEN = 'feron_admin_token';

export const getAdminToken = () => {
  try { return localStorage.getItem(LS_ADMIN_TOKEN); } catch { return null; }
};
export const setAdminToken = (t) => {
  try { if (t) localStorage.setItem(LS_ADMIN_TOKEN, t); else localStorage.removeItem(LS_ADMIN_TOKEN); } catch {}
};

const admin = axios.create({ baseURL: API_BASE, withCredentials: true });
admin.interceptors.request.use((cfg) => {
  const token = getAdminToken();
  if (token) cfg.headers['X-Admin-Token'] = token;
  return cfg;
});

export const adminLogin = (password) => admin.post('/admin/login', { password }).then((r) => r.data);
export const adminLogout = () => admin.post('/admin/logout').then((r) => r.data);

export const adminFetchProducts = (q = '') => admin.get('/admin/products', { params: q ? { q } : {} }).then((r) => r.data);
export const adminCreateProduct = (payload) => admin.post('/admin/products', payload).then((r) => r.data);
export const adminBulkUpload = (csvText) => admin.post('/admin/products/bulk', { csv_text: csvText }).then((r) => r.data);
export const adminUpdateProduct = (id, patch) => admin.patch(`/admin/products/${id}`, patch).then((r) => r.data);
export const adminDeleteProduct = (id) => admin.delete(`/admin/products/${id}`).then((r) => r.data);
export const adminBulkDeleteProducts = (ids) => admin.post('/admin/products/bulk-delete', { product_ids: ids }).then((r) => r.data);
export const adminBulkStock = (ids, patch) => admin.post('/admin/products/bulk-stock', { product_ids: ids, ...patch }).then((r) => r.data);

// Media upload (image or video). Returns { url, kind, size, name }
export const adminUploadFile = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return admin.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};

export const adminFetchOrders = (q = '') => admin.get('/admin/orders', { params: q ? { q } : {} }).then((r) => r.data);
export const adminFetchOrder = (orderId) => admin.get(`/admin/orders/${orderId}`).then((r) => r.data);
export const adminUpdateOrderStatus = (orderId, status) =>
  admin.patch(`/admin/orders/${orderId}/status`, { status }).then((r) => r.data);
export const adminUpdateOrderTracking = (orderId, patch) =>
  admin.patch(`/admin/orders/${orderId}/tracking`, patch).then((r) => r.data);
export const adminBulkOrderStatus = (order_ids, status) =>
  admin.patch(`/admin/orders/bulk-status`, { order_ids, status }).then((r) => r.data);
export const adminFetchStats = () => admin.get('/admin/stats').then((r) => r.data);

export const adminFetchReviews = () => admin.get('/admin/reviews').then((r) => r.data);
export const adminToggleHideReview = (rid) => admin.patch(`/admin/reviews/${rid}/hide`).then((r) => r.data);
export const adminDeleteReview = (rid) => admin.delete(`/admin/reviews/${rid}`).then((r) => r.data);

// --- Coupons ---
export const adminFetchCoupons = () => admin.get('/admin/coupons').then((r) => r.data);
export const adminCreateCoupon = (payload) => admin.post('/admin/coupons', payload).then((r) => r.data);
export const adminUpdateCoupon = (code, patch) => admin.patch(`/admin/coupons/${code}`, patch).then((r) => r.data);
export const adminDeleteCoupon = (code) => admin.delete(`/admin/coupons/${code}`).then((r) => r.data);

// Test-order cleanup
export const adminCleanupTestOrders = ({ days = 30, email_domain = 'feronstore.com', dry_run = false } = {}) =>
  admin.delete('/admin/orders/test-cleanup', { params: { days, email_domain, dry_run } }).then((r) => r.data);

// --- Taxonomies (types, collections, categories) ---
export const adminFetchTaxonomies = (kind) =>
  admin.get('/admin/taxonomies', { params: kind ? { kind } : {} }).then((r) => r.data);
export const adminCreateTaxonomy = (payload) => admin.post('/admin/taxonomies', payload).then((r) => r.data);
export const adminUpdateTaxonomy = (id, patch) => admin.patch(`/admin/taxonomies/${id}`, patch).then((r) => r.data);
export const adminDeleteTaxonomy = (id, force = false) =>
  admin.delete(`/admin/taxonomies/${id}`, { params: force ? { force: true } : {} }).then((r) => r.data);
export const adminReorderTaxonomies = (kind, ordered_ids) =>
  admin.patch('/admin/taxonomies/reorder', { kind, ordered_ids }).then((r) => r.data);

// --- Support chat (admin inbox) ---
export const adminChatConversations = () => admin.get('/admin/chat/conversations').then((r) => r.data);
export const adminChatUnreadTotal = () => admin.get('/admin/chat/unread-total').then((r) => r.data);
export const adminChatThread = (userId) => admin.get(`/admin/chat/conversations/${userId}`).then((r) => r.data);
export const adminChatReply = (userId, text) => admin.post(`/admin/chat/conversations/${userId}/reply`, { text }).then((r) => r.data);

export default admin;
